<template>
  <div>
    <ed-cid :intCidId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdCid from "@/components/cadastro/cid/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdCid },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "cadastro.cid.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>